import { CkeckColor } from "hooks/layout-hooks"
import { useEffect, useState } from "react"
import { ConvertMiladiToJalali, methodCheckIsActiveFields } from "utils/layout-utils"

export const DrawDown = ({ account, metrics, statics, licence }: any) => {
    let [percent, setPercent] = useState({
        'daily': 0,
        'total': 0,
    })

    useEffect(() => {
        if (statics) {
            setPercent({
                'daily': (Math.abs(statics?.daily_drawdown?.daily_loss_limit_current) * 100) / Math.abs(statics?.daily_drawdown?.daily_loss_limit_target),
                'total': (Math.abs(statics?.current_total_drawdown) * 100) / Math.abs(statics?.total_drawdown)
            })
        }
    }, [statics])

    return (
        <>

            <div className="md:min-h-[464px] mni-h-[auto] flex flex-col w-full pt-5 pb-2 rounded-md bg-trade-50">
                <div className="md:w-[80%] w-full md:px-0 px-2 mx-auto flex flex-col">
                    <div className="relative flex items-center justify-between w-full font-bold text-white">
                        <div className="flex flex-col items-center">
                            <svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                                <circle className="circle-chart__background" stroke="#4e545a" stroke-width="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                                <circle className="circle-chart__circle" stroke="#2563eb" stroke-width="2" stroke-dasharray={`${percent.daily} 100`} stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                                <g >
                                    {/* <text x="16.91549431" y="19.0" alignment-baseline="central" text-anchor="middle" font-size="5" fill="#fff">{Math.abs(statics?.daily_drawdown?.daily_loss_limit_target?.toFixed(0))} / {Math.abs(statics?.daily_drawdown?.daily_loss_limit_current?.toFixed(0))}</text> */}
                                    <text x="22" y="18.7" alignment-baseline="central" text-anchor="middle" font-size="5" fill='#fff'>{Math.abs(statics?.daily_drawdown?.daily_loss_limit_target?.toFixed(0))} /</text>
                                    <text x="9" y="18.7" alignment-baseline="central" text-anchor="middle" font-size="5" fill="#b33b3f">{Math.abs(statics?.daily_drawdown?.daily_loss_limit_current?.toFixed(0))}</text>
                                </g>
                            </svg>
                            <span className="mt-2 text-sm">دراودان روزانه</span>
                        </div>
                        <div className="flex flex-col items-center">
                            <svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                                <circle className="circle-chart__background" stroke="#4e545a" stroke-width="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                                <circle className="circle-chart__circle" stroke="#2563eb" stroke-width="2" stroke-dasharray={`${percent.total} 100`} stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                                <g >
                                    {/* <text x="16.91549431" y="19.0" alignment-baseline="central" text-anchor="middle" font-size="5" fill={`${statics?.current_total_drawdown > 0 ? '#178c46' : '#b33b3f'}`}>{Math.abs(statics?.total_drawdown?.toFixed(0))} / {Math.abs(statics?.current_total_drawdown?.toFixed(0))}</text> */}
                                    <text x="22" y="18.7" alignment-baseline="central" text-anchor="middle" font-size="5" fill='#fff'>{Math.abs(statics?.total_drawdown?.toFixed(0))} /</text>
                                    <text x="9" y="18.7" alignment-baseline="central" text-anchor="middle" font-size="5" fill="#b33b3f">{Math.abs(statics?.current_total_drawdown?.toFixed(0))}</text>
                                </g>
                            </svg>
                            <span className="mt-2 text-sm">دراودان کلی</span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center w-full px-2 mx-auto mt-7">
                    {methodCheckIsActiveFields('balance') &&
                        <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>بالانس اکانت</span>
                            <span>{account?.balance}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('account_target') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>هدف سود </span>
                            {account?.level == 3 || account?.challenge_type == 'trade_competitions' ? 
                                <span className="text-2xl">∞</span>
                                :
                                <span>{+statics?.account_target + +account?.balance}</span>
                            }
                        </div>
                    }
                    {methodCheckIsActiveFields('created_at') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>زمان خرید چالش</span>
                            <span>{ConvertMiladiToJalali(licence?.created_at)}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('licence_expired_at') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span> زمان پایان چالش</span>
                            <span>{ConvertMiladiToJalali(licence?.licence_expired_at)}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('Total_profit_and_loss_percentage') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span> درصد سود / زیان کلی</span>
                            <span className="">
                                {CkeckColor(account?.data?.data?.analyze?.Total_profit_and_loss_percentage?.toFixed(2), '%')}
                            </span>
                        </div>
                    }
                    {methodCheckIsActiveFields('Today_profit_and_loss_percentage_based_on_balance') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span> درصد سود / زیان روزانه </span>
                            <span className="">
                                {CkeckColor(account?.data?.data?.analyze?.Today_profit_and_loss_percentage_based_on_balance.toFixed(2), '%')}
                            </span>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}